// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".add-profile-info-popup[data-v-714880ed]{font-size:18px}\n", ""]);
// Exports
module.exports = exports;
